export default __webpack_public_path__ + "2ed4f163a23452e4ff14349e8377bef1.png";